import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Table, Params } from 'nallian-table-builder-ui';
import apiRoutes from '../../../../app/api/routes';

const AppInstallationCommunities = () => {
  const { t } = useTranslation();
  const { id, installationId } = useParams();

  return (
    <>
      <Table
        resource={`installations_community_${id}_${installationId}`}
        url={apiRoutes.appInstallationCommunities(id, installationId)}
        noResultsMessage={t('noCommunitiesFound')}
        pageSize={50}
        idProp="id"
        noUserSettings
        filtered
        sorted
      >
        <Params.String
          link="/communities/edit/:id/apps"
          name="name"
          width="16rem"
          minWidth="16rem"
          grow
          noFilter
        />
        <Params.String name="tag" width="16rem" minWidth="16rem" grow noFilter />
      </Table>
    </>
  );
};

export default AppInstallationCommunities;
